export default "__VITE_ASSET__DorWjzuN__"